// The sign-off method keys the Employee Reviews API returns. Resolved by key because
// lck.Review_Sign_Off_Method ids come from a static-data MERGE rather than an IDENTITY
// column, so they are declared rather than generated.

export const physicalSignOffMethodKey = "PHYSICAL";
export const onScreenSignOffMethodKey = "ONSCREEN";
export const emailSignOffMethodKey = "EMAIL";
export const appSignOffMethodKey = "APP";
